import { defineClientModule } from '../client-module';

export const organizationsModule = defineClientModule({
  id: 'organizations',
  recordTypeKey: 'organization',
  label: 'Overview',
  route: '/organizations/overview',
  navGroup: 'Workspace',
  icon: 'Building2',
  description: 'Everything One Up is doing for you, in one place.',
  view: 'organizations',
  emptyState: {
    title: 'Your workspace isn’t ready yet.',
    body: 'Message the One Up team and we’ll get your account connected.',
  },
});

export const aliceActivityModule = defineClientModule({
  id: 'alice-activity',
  recordTypeKey: 'ai_activity',
  label: 'AI Usage',
  route: '/ai-systems/alice-activity',
  navGroup: 'AI Systems',
  icon: 'Sparkles',
  description: 'Recent assistant outcomes and your workspace request allowance.',
  view: 'alice-activity',
  emptyState: {
    title: 'No AI activity yet.',
    body: 'Assistant requests and their outcomes will appear here.',
  },
});

export const switchboardModule = defineClientModule({
  id: 'switchboard',
  recordTypeKey: 'automation',
  // The client-facing name is "Automations" — "Switchboard" is our word for it,
  // not theirs. The route stays put so existing links keep working.
  label: 'Automations',
  route: '/switchboard',
  navGroup: 'AI Systems',
  icon: 'ToggleRight',
  description: 'The automations running behind the scenes for your business, and how much they have done this month.',
  view: 'switchboard',
  emptyState: {
    title: 'No automations set up yet.',
    body: 'When One Up switches an automation on for you, it appears here with its status and monthly activity.',
  },
});
